import React, { useEffect, useState } from 'react';
import TableDataLayer from "../components/TableDataLayer";
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link, NavLink } from 'react-router-dom';
import { apiCall } from "../utils/apiService";

const InstanceLayer = () => {
    const [data, setData] = useState([]);
    const [copySuccess, setCopySuccess] = useState("Copy");

    const fetchInstances = async () => {
        try {
            const response = await apiCall({
                url: `sessions/get-users-instances`,
                method: 'GET',
            });
            setData(response.total);
            return response
        } catch (error) {
            console.error('Error fetching dashboard:', error);
        }
    };

    // handle group list code
    const handleGroupList = async (instanceId) => {
        try {
            const response = await apiCall({
                url: `groups?id=${instanceId}`,
                method: 'GET',
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching dashboard:', error);
        }
    };

    const createJSONFile = async (instanceId, name) => {
        const groups = await handleGroupList(instanceId);
        let data = groups.map((chat) => {
            return { id: chat.id, name: chat.name }
        })
        const dataStr = JSON.stringify(data, null, 2);
        const dataUri = 'data:application/json;charset=utf-8,' + encodeURIComponent(dataStr);
        const link = document.createElement('a');
        link.setAttribute('href', dataUri);
        link.setAttribute('download', `Groups-${name}.json`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleChangeStatus = async (status, id) => {
        try {
            const response = await apiCall({
                url: `sessions/update-instance-status`,
                method: 'POST',
                body: {status: !status, client_id: id}
            });
            if (response.success) {
                setData(data - 1);
            }
            return response
        } catch (error) {
            console.error('Error updating instance status:', error);
        }
    };

    const removeInstance = async (id) => {
        try {
            const response = await apiCall({
                url: `sessions/delete/${id}`,
                method: 'DELETE',
            });
            if (response.success) {
                setData(data - 1);
            }
        } catch (error) {
            console.error('Error fetching dashboard:', error);
        }
    };

    const removeMessageLog = async (selected, type = null) => {
        try {
            const response = await apiCall({
                url: `user/del-logs`,
                method: 'POST',
                body: { selected: selected, type: type }
            });
            if (response.success) {
                setData(data - 1);
            }
        } catch (error) {
            console.error('Error fetching dashboard:', error);
        }
    };

    const handleCopy = async (id) => {
        try {
            await navigator.clipboard.writeText(id);
            setCopySuccess("Copied to clipboard!");
            setTimeout(() => {
                setCopySuccess("Copy");
            }, 2000);
        } catch (err) {
            setCopySuccess("Failed to copy!");
            console.error("Failed to copy text:", err);
        }
    };

    const columns = [
        { key: 'id', label: 'ID' },
        { key: 'name', label: 'Name' },
        {
            key: 'status',
            label: 'Status',
            render: (val, row) => (
                <span className={`badge bg-${row.status == 1 ? 'success-main' : 'danger'}`}>
                    {row.status == 1 ? 'Active' : 'InActive'}
                </span>
            ),
        },
        { key: 'delay', label: 'Delay' },
        {
            key: 'createdAt',
            label: 'Created At',
            render: (val, row) => {
                const date = new Date(row.createdAt);
                return date.toLocaleString();
            },
        },
        {
            key: 'actions',
            label: 'Actions',
            render: (val, row) => (
                <>
                    <button
                        title={row.status == 1 ? "Pause" : "Play"}
                        onClick={()=>handleChangeStatus(row.status, row.client_id)}
                        className="w-32-px h-32-px me-8 bg-warning-focus text-warning-600 rounded-circle d-inline-flex align-items-center justify-content-center"
                    >
                        <Icon icon={row.status == 1 ? "mingcute:pause-line" : "mingcute:play-line"} />
                    </button>
                    <button
                        to="#"
                        title={copySuccess}
                        onClick={() => handleCopy(row.client_id)}
                        as={NavLink}
                        className="w-32-px h-32-px me-8 bg-success-focus text-success-600 rounded-circle d-inline-flex align-items-center justify-content-center"
                    >
                        <Icon icon="iconamoon:copy-light" />
                    </button>
                    <button
                        onClick={() => removeMessageLog(row.client_id, 'instance')}
                        title="Delete Logs"
                        className="w-32-px h-32-px me-8 bg-info-focus text-info-main rounded-circle d-inline-flex align-items-center justify-content-center"
                    >
                        <Icon icon="lucide:x" />
                    </button>
                    <button
                        onClick={() => createJSONFile(row.client_id, row.name)}
                        title="Download Groups"
                        className="w-32-px h-32-px me-8 bg-indigo-focus text-indigo rounded-circle d-inline-flex align-items-center justify-content-center"
                    >
                        <Icon icon="mingcute:arrow-down-line" />
                    </button>
                    <button
                        onClick={() => removeInstance(row.client_id)}
                        title="Delete Instance"
                        className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                    >
                        <Icon icon="mingcute:delete-2-line" />
                    </button>
                </>

            ),
        },
    ];

    useEffect(() => {
        document.title = 'Instance List'
    }, [])

    return (
        <>
            {/* TableDataLayer */}
            <div className="card basic-data-table">
                <div className="card-header">
                    <div className="d-flex justify-content-between alig-items-center">
                        <h5 className="card-title mb-0">Instance List</h5>
                        <div>
                            <Link to="/scan-instance" className="btn btn-success">Scan Instance</Link>
                        </div>
                    </div>
                </div>
                <TableDataLayer
                    columns={columns}
                    totalRows={data}
                    fetchData={fetchInstances}
                />
            </div>
        </>
    );
}

export default InstanceLayer